import React, { useEffect, useState } from 'react';
import { Button, Modal, Nav, NavLink, Navbar } from 'react-bootstrap';
import { options, selectField } from './field-options';
import FieldInput from './field-input';
import { EditDynamicFieldRepository } from '../../../../services/api/dynamic-fields-api';
import { errorNotification, successNotification } from "../../../../redux/notifications";
import { useDispatch } from 'react-redux';
import PropTypes from "prop-types";
import { FluentMenu } from '../../../../components/FluentUI/Fluent-Menu';
import { FluentTooltip } from '../../../../components/FluentUI/Fluent-Tooltip';
import FluentUiIcon from '../../../../assets/fluent-ui-icon';
import _ from "lodash";

const EditField = ({ isEdit, setIsEdit, show, onHide, selectedField, GetFieldRepository, canEdit }) => {

    const dispatch = useDispatch();
    const [fieldType, setFieldType] = useState();
    const [fieldValues, setFieldValues] = useState(selectedField);
    const [currentTab, setCurrentTab] = useState('Details');

    useEffect(() => {
        options.forEach((option) => {
            option.fields.forEach((field) => {
                if (field.value === selectedField.FieldType) {
                    setFieldType(field)
                }
            })
        });
    }, [selectedField])

    const onEditField = () => {
        EditDynamicFieldRepository(fieldValues)
            .then((res) => {
                if (res.status === 200) {
                    GetFieldRepository();
                    onHide();
                    dispatch(successNotification({
                        header: "Field Updated",
                        message: `The field "${fieldValues.Label}" has been updated successfully`
                    }));
                }
                else{
                    onHide();
                    dispatch(errorNotification({
                        header: "Field Update failed",
                        message: "The field could not be updated" + res
                    }));
                }
            })
            .catch((err) => {
                onHide();
                dispatch(errorNotification({
                    header: "Field Update failed",
                    message: "The field could not be updated" + err?.toString()
                }));
                console.log("Error [GetAllWorkflows] => ", err);
            });
    }

    const onCancel = () => {
        setIsEdit(false);
        setFieldValues(selectedField);
    }

    const ParseAddToSectionItems = (listener, items) => {
      let textOptions = _.cloneDeep(items[0]);

      return textOptions?.fields?.map((item) => {
        return {
          Text: (
            <div className="text-dropdown">
              <div className="icon-circle-sm">
                <FluentUiIcon name={item?.icon} size={20} />
              </div>
              <div className="dropdown-text">{item.label}</div>
            </div>
          ),
          Value: item.value,
          onClick: function (e) {
            let newFieldType = textOptions.fields.find((field) => field.value === item.value);
            if(newFieldType.value !== fieldType.value) {
                let newFieldValues = {...fieldValues, FieldType: newFieldType.value};
                setFieldType(newFieldType);
                setFieldValues(newFieldValues);
            }
          },
        };
      });
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            contentClassName="dashboard-modal-styles fieldRepoModal"
            dialogClassName="dashboard-modal"
            scrollable={true}
        >
            <Modal.Header
                className="dashboard-modal-header"
                closeButton
            >
                <Modal.Title className="modal-title">
                    <div className='field-modal-subtitle'>Data Field</div>
                    <span>{selectedField.Label}</span>
                </Modal.Title>
            </Modal.Header>

            {fieldType && <Modal.Body className="field-input">
                <div className='edit-field-nav'>
                    <Navbar>
                        <Nav variant="pills">
                            <Nav.Item className='field-nav-link' onClick={() => setCurrentTab("Details")}>
                                <NavLink className={`${currentTab === "Details" ? "isActive" : ""}`} to="/dashboard" >
                                    Details
                                </NavLink>
                            </Nav.Item>
                            <Nav.Item className='field-nav-link'>
                                <NavLink disabled onClick={() => setCurrentTab("TaskTypes")} className={`${currentTab === "TaskTypes" ? "isActive" : ""}`} to="/projects">
                                    Task Types
                                </NavLink>
                            </Nav.Item>
                            <Nav.Item className='field-nav-link'>
                                <NavLink disabled onClick={() => setCurrentTab("ProjectTemplates")} className={`${currentTab === "ProjectTemplates" ? "isActive" : ""}`} to="/projects">
                                    Project Templates
                                </NavLink>
                            </Nav.Item>
                        </Nav>
                    </Navbar>
                    {!isEdit && canEdit ?
                        <Button className="btn-outlined" variant="primary" onClick={() => setIsEdit(true)}>Edit</Button>
                        : isEdit && <div className="action-btns">
                            <Button className="btn-outlined"
                                onClick={onCancel}
                                variant="primary">
                                Cancel
                            </Button>
                            <Button
                                onClick={onEditField}
                                disabled={fieldValues.Label.length < 1}
                                className=""
                                variant="primary">
                                Save
                            </Button>
                        </div>}         
                </div>       
                {currentTab == "Details" && <>
                    <div className='field-create-edit-btn'>
                        {isEdit && (fieldType.value === 'Short Text Entry' || fieldType.value === 'Long Text Entry') ?
                        <FluentMenu
                            button={<div className='field-options'>{<FluentTooltip positioning='below-start' text="Switch field type" target={selectField({ fields: [fieldType] }, setFieldType, null, false)} />}</div>}
                            items={ParseAddToSectionItems(null, options)}
                            selected={fieldType.value}
                        ></FluentMenu> : 
                        selectField({ fields: [fieldType] }, setFieldType, null, false)}
                    </div>
                    <FieldInput
                        disabled={!isEdit}
                        fieldValues={fieldValues}
                        setFieldValues={setFieldValues} />
                </>}
            </Modal.Body>}
        </Modal>
    );
}

EditField.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    setIsEdit: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    selectedField: PropTypes.shape({
        FieldType: PropTypes.string,
        Label: PropTypes.string,
    }).isRequired,
    GetFieldRepository: PropTypes.func.isRequired,
    canEdit: PropTypes.bool,
};

export default EditField;